import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { Suspense, useEffect } from 'react'
import { lazyWithRetry } from './utils/lazyWithRetry'
import Header from './components/Header'
import Footer from './components/Footer'
import WhatsAppFloat from './components/WhatsAppFloat'
import GoogleAnalytics from './components/SEO/GoogleAnalytics'
import Breadcrumbs from './components/Breadcrumbs'
import Egg from './brand/EasterEgg/Egg'
import { REDIRECTS } from './redirects'

// Páginas (D22: Zentriz como empresa de IA — a suíte Genesis ↔ Connect ↔ Auto Care é o site)
import Home from './pages/Home'
const Platform = lazyWithRetry(() => import('./pages/Platform'), 'Platform')
const Plans = lazyWithRetry(() => import('./pages/Plans'), 'Plans')
const Cases = lazyWithRetry(() => import('./pages/Cases'), 'Cases')
const Genesis = lazyWithRetry(() => import('./pages/Products/Genesis'), 'Products/Genesis')
const Connect = lazyWithRetry(() => import('./pages/Products/Connect'), 'Products/Connect')
const AutoCare = lazyWithRetry(() => import('./pages/Products/AutoCare'), 'Products/AutoCare')
const About = lazyWithRetry(() => import('./pages/About'), 'About')
const Zeta = lazyWithRetry(() => import('./pages/Zeta'), 'Zeta')
const Contacts = lazyWithRetry(() => import('./pages/Contacts'), 'Contacts')
const Terms = lazyWithRetry(() => import('./pages/Terms'), 'Terms')
const Privacy = lazyWithRetry(() => import('./pages/Privacy'), 'Privacy')
const NotFound = lazyWithRetry(() => import('./pages/NotFound'), 'NotFound')
const Sandbox = lazyWithRetry(() => import('./pages/Sandbox'), 'Sandbox')

// Component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

function App() {
  const { t } = useTranslation()

  return (
    <>
      <GoogleAnalytics trackingId="G-XSVE1036D6" />
      <Helmet>
        <title>{t('meta.title')}</title>
        <meta name="description" content={t('meta.description')} />
        <meta name="keywords" content={t('meta.keywords')} />
        <meta name="author" content="Zentriz" />
        <meta property="og:title" content={t('meta.title')} />
        <meta property="og:description" content={t('meta.description')} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Zentriz" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('meta.title')} />
        <meta name="twitter:description" content={t('meta.description')} />
      </Helmet>

      <ScrollToTop />

      <div className="app-shell">
        <Header />
        <Breadcrumbs />

        <main>
          <Suspense fallback={<div style={{ minHeight: '100vh' }} aria-busy="true" />}>
          <Routes>
            <Route path="/" element={<Home />} />

            {/* Autonomy Suite (D26: Plataforma · Planos · Casos · Contato no menu; as três peças sob Plataforma) */}
            <Route path="/platform" element={<Platform />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/cases" element={<Cases />} />
            <Route path="/genesis" element={<Genesis />} />
            <Route path="/connect" element={<Connect />} />
            <Route path="/auto-care" element={<AutoCare />} />

            {/* Institucional */}
            <Route path="/about" element={<About />} />
            <Route path="/brand" element={<Zeta />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            {/* bancada dos componentes de marca — noindex, fora do sitemap (docs/GATES.md) */}
            <Route path="/__sandbox" element={<Sandbox />} />

            {/* Rotas da v1 / v2-completa → destino novo (src/redirects.ts). Não são rotas do site: ficam fora do state-map e do sitemap. */}
            {Object.entries(REDIRECTS).map(([from, to]) => <Route key={from} path={from} element={<Navigate to={to} replace />} />)}

            {/* 404 - Catch all route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          </Suspense>
        </main>

        <Footer />
        <WhatsAppFloat />
        <Egg />
      </div>
    </>
  )
}

export default App
